import { gql } from "@apollo/client";

export const GET_CUSTOMER_CREDIT_NOTES = gql`
  query creditNotesByCustomerId($id: String!) {
    creditNotesByCustomerId(id: $id) {
      id
      creditNoteRef
      creditNoteType
      createdAt
      invoice {
        id
        invoiceRef
      }
      totalAmount
      refundedAmount
      availableAmount
      creditNoteItems {
        type
        description
        originalPrice
        quantity
        unitPrice
        totalAmount
        duration
      }
      refunds {
        mode
        amount
        status
        id
        refundRef
        currency
        paymentIntent
      }
      allocations {
        amount
        allocatedAt
        invoice {
          invoiceRef
        }
      }
    }
  }
`;
